export default "__VITE_ASSET__CDJRMshs__"